import PropTypes from "prop-types";

import { copyrightCss } from "./ContentDisplayCopyright.style";

const propTypes = {
  copyright: PropTypes.string,
};

const ContentDisplayCopyright = ({ copyright }) => {
  if (!copyright) {
    return null;
  }

  return (
    <div css={copyrightCss}>
      {copyright.replace("{year}", new Date().getFullYear())}
    </div>
  );
};

ContentDisplayCopyright.propTypes = propTypes;

export default ContentDisplayCopyright;
